/**
 * Real proof content for the public site: case studies and testimonials.
 *
 * These arrays are intentionally EMPTY. Adding credibility content is a data
 * edit here — no component changes needed. `ProofSection` renders nothing while
 * both arrays are empty, so the site never ships fabricated or unapproved
 * client claims.
 *
 * Only add entries you have permission to publish (client sign-off for named
 * work, real quotes, and metrics you can substantiate). The first strong
 * candidate is the Justice Informed "Build an AI Operator" engagement once it
 * is cleared for a public case study.
 *
 * Template:
 *   {
 *     slug: "justice-informed-operator",
 *     client: "Justice Informed",         // omit or anonymize if not cleared
 *     service: "Build an AI Operator",
 *     entryPath: "/ai-operators",
 *     summary: "One or two sentences on the problem SVM solved.",
 *     outcomes: ["Concrete, substantiated result", "Another result"],
 *   }
 */

export interface CaseStudy {
  slug: string;
  /** Named client only when cleared for publication; otherwise anonymize. */
  client?: string;
  service: string;
  /** Route to the matching service page, e.g. "/ai-operators". */
  entryPath?: string;
  summary: string;
  outcomes: string[];
}

export interface Testimonial {
  quote: string;
  author: string;
  role?: string;
  /** Named organization only when cleared for publication. */
  org?: string;
}

export const caseStudies: CaseStudy[] = [];

export const testimonials: Testimonial[] = [];

export function hasProofContent(): boolean {
  return caseStudies.length > 0 || testimonials.length > 0;
}
